import React from "react";
import { useAuth } from "@/context/AuthContext";
import FamilyPortal from "@/pages/portal/FamilyPortal";
import ClientPortalHome from "@/pages/portal/ClientPortalHome";
import PartnerPortal from "@/pages/portal/PartnerPortal";
import PurchaserPortal from "@/pages/portal/PurchaserPortal";

// Role-based dispatcher for the portal home (/portal).
export default function PortalHome() {
  const { user } = useAuth();
  const role = user?.role;
  if (role === "partner_vendor") return <PartnerPortal />;
  if (role === "purchaser_portal_user") return <PurchaserPortal />;
  if (role === "client") return <ClientPortalHome />;
  return <FamilyPortal />;
}
